import { useEffect, useState } from "react";
import { useAuth } from "../contexts/AuthCtx";
import { motion } from "framer-motion";
import useTypewriter from "../hooks/useTypewriter";

// const HeroSection = ({ hasScrolled }) => {

//     const [sliderimages, setSliderimages] = useState([{
//       img: "https://s7ap1.scene7.com/is/image/TCSCOMprod/worldwide-hub-hero-banner-Web?wid=3500&hei=1379&dpr=off",
//       h1: "NURTURING CONCEPTS INTO REALITIES.",
//       p: [
//         "We're the leading web development and software solutions provider company including hosting in India and worldwide.",
//         "Start the journey with us and feel the difference."
//       ]
//     }]);
//     const [activeSlide, setActiveSlide] = useState(0);

//     const authCtx = useAuth();

//     const handleLeft = (e) => {
//       // slide left
//     }

//     const handleRight = (e) => {
//       // slide right
//     }

//     return (
//       <section className={("hero-section") + (hasScrolled > 0 ? " has-scrolled" : "")}>
//         <div className="inner">
//           <div className="image">
//             <img src="https://s7ap1.scene7.com/is/image/TCSCOMprod/worldwide-hub-hero-banner-Web?wid=3500&hei=1379&dpr=off" />
//           </div>
//           <div className="overlay-controls">
//             <div className="caption">
//               <h1>{sliderimages[activeSlide].h1}</h1>
//                 {sliderimages[activeSlide].p.map((p, i) => {
//                   return (
//                     <p key={`${i}`}>
//                       {p}
//                     </p>
//                   );
//                 })}
//               <div style={{ marginTop: 24 }}>
//                 <button onClick={(e) => authCtx.toggleShowStartProjectDialog(true)} className="text-button">START PROJECT {'↗'}</button>
//               </div>
//             </div>
//             <div className="control">
//               <div className="inner-control">
//                 <span onClick={handleLeft}>&larr;</span>
//                 <span onClick={handleRight}>&rarr;</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     );
//   }

const getBlogCardVariant = (i) => {
  return {
    hidden: { opacity: 0, y: 100 }, // Start from the left
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, delay: 0.4 } // Add a slight delay based on the card index
    }
  };
}

const HeroSection = ({ hasScrolled }) => {
  const [sliderimages, setSliderimages] = useState([{
    img: "https://s7ap1.scene7.com/is/image/TCSCOMprod/worldwide-hub-hero-banner-Web?wid=3500&hei=1379&dpr=off",
    h1: "NURTURING CONCEPTS INTO REALITIES.",
    p: [
      "We're the leading web development and software solutions provider company including hosting in India and worldwide.",
      "Start the journey with us and feel the difference."
    ]
  },
  {
    img: "https://f.start.me/us.gov",
    h1: "We work with well documented and effective structure.",
    p: [
      "Join in 400+ of our customers.",
    ]
  },
  {
    img: "https://f.start.me/gov.fr",
    h1: "Enjoy the benefits from us.",
    p: [
      "With the contract we will assign a team for you and along with this you will get a free domain. Terms applies.",
    ]
  }
  ]);
  const [activeSlide, setActiveSlide] = useState(0);
  const [direction, setDirection] = useState(0); // 1 for right, -1 for left

  const authCtx = useAuth();

  const handleLeft = () => {
    setDirection(-1);
    setActiveSlide((prev) => (prev > 0 ? prev - 1 : sliderimages.length - 1));
  }

  const handleRight = () => {
    setDirection(1);
    setActiveSlide((prev) => (prev < sliderimages.length - 1 ? prev + 1 : 0));
  }

  const variants = {
    enter: (direction) => {
      return {
        y: direction > 0 ? 1000 : -1000,
        opacity: 0
      };
    },
    center: {
      // zIndex: 1,
      y: 0,
      opacity: 1
    },
    exit: (direction) => {
      return {
        zIndex: 0,
        y: direction > 0 ? -1000 : 1000,
        opacity: 0
      };
    }
  };

  useEffect(() => {
    setInterval(() => {
      handleRight();
    }, 6000);
  }, []);

  // return (
  //   <section className={("hero-section") + (hasScrolled > 0 ? " has-scrolled" : "")}>
  //     <div className="inner">
  //       <div className="image">
  //         {/* <motion.img
  //           key={sliderimages[activeSlide].img}
  //           src={sliderimages[activeSlide].img}
  //           custom={direction}
  //           initial="enter"
  //           animate="center"
  //           exit="exit"
  //           variants={variants}
  //           transition={{ duration: 0.5 }}
  //         /> */}
  //       </div>
  //       <div className="overlay-controls">
  //         <div className="caption">
  //           <h1>{sliderimages[activeSlide].h1}</h1>
  //           {sliderimages[activeSlide].p.map((p, i) => {
  //             return (
  //               <p key={`${i}`}>
  //                 {p}
  //               </p>
  //             );
  //           })}
  //           <div style={{ marginTop: 24 }}>
  //             <button onClick={() => authCtx.toggleShowStartProjectDialog(true)} className="text-button">START PROJECT {'↗'}</button>
  //           </div>
  //         </div>
  //         <div className="control">
  //           <div className="inner-control">
  //             <span onClick={handleLeft}>&larr;</span>
  //             <span onClick={handleRight}>&rarr;</span>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </section>
  // );

  return (
    <section className={("hero-section") + (hasScrolled > 0 ? " has-scrolled" : "")}>
      <div className="inner">
        <div className="image">
          <img
            src={"/images/hero_backimg.jpg"}
          />
        </div>
        <div className="overlay-controls">
          <div className="inner">
            <div className="caption">
              <h1>{"NURTURING CONCEPTS INTO REALITIES"}</h1>
              <p className="bigp">Start the journey with us and feel the difference, get started today and have a free consultation</p>
              <div style={{ marginTop: 24 }}>
                <button onClick={() => {
                  // authCtx.toggleShowStartProjectDialog(true);
                  authCtx.setGetQuote(true);
                }} className="text-button">START PROJECT {'↗'}</button>
              </div>
            </div>
            {/* <div className="control">
              <div className="inner-control">
                <span onClick={handleLeft}>&larr;</span>
                <span onClick={handleRight}>&rarr;</span>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );

  // const handleSubmitForm = (e) => {

  // }

  // return (
  //   <section className={("hero-section") + (hasScrolled > 0 ? " has-scrolled" : "")}>
  //     <div className="inner">
  //       <div className="overlay-controls">
  //         <div className="caption">
  //           <h1>{"NURTURING CONCEPTS INTO REALITIES."}</h1>
  //           <p></p>
  //           <div style={{ marginTop: 24 }}>
  //             <button onClick={() => authCtx.toggleShowStartProjectDialog(true)} className="text-button">START PROJECT {'↗'}</button>
  //           </div>
  //         </div>
  //       </div>
  //         <form className="hero-form" onSubmit={handleSubmitForm}>
  //         <div className="field">
  //           <div className="label">Name/Company</div>
  //           <div className="control">
  //             <input type="text" required />
  //           </div>
  //         </div>
  //         <div className="field">
  //           <div className="label">Email</div>
  //           <div className="control">
  //             <input name="email" required type="email" />
  //           </div>
  //         </div>
  //         <div className="field">
  //           <div className="label">Mobile</div>
  //           <div className="control">
  //             <input name="mobile" type="mobile" />
  //           </div>
  //         </div>
  //         <div className="field">
  //           <div className="label">Describe</div>
  //           <div className="control">
  //             <textarea name="describe" required></textarea>
  //           </div>
  //         </div>
  //         <div className="field">
  //           <div className="control">
  //             <button type="submit">Submit</button>
  //           </div>
  //           <div className="desc">
  //             <p>By submitting the form you agree to our terms & service and consent us to reach you back for the same.</p>
  //           </div>
  //         </div>
  //       </form>
  //     </div>
  //   </section>
  // );
}


export default HeroSection;